module.exports = __webpack_public_path__ + "img/guarantee-100-satisfaction.b6c03568.png";